import { useParams } from "react-router-dom";
import { useIntl } from "../../lib/i18n";

export default function MatterConflictLogPage() {
  const { matterId = "" } = useParams();
  const { t } = useIntl();
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">
        {t("matter_detail.conflict_log")} — {matterId}
      </h1>
      <p className="mt-4 text-slate-500">
        {t("conflict.empty")}
      </p>
    </div>
  );
}
